import "./fotos2.css"
function FotosManoel(){
return(


<div className="fotosManoel">

                <img src="images/Barreiras.jpeg" alt="" />
            
                <img src="images/cabeco.jpeg" alt="" />
           
         
                <img src="images/Capela.jpeg" alt="" />

           

        
      
          
                <img src="images/ponte.jpeg" alt="" />
           
           
                <img src="images/restaurante.jpeg" alt="" />
           
          
                <img src="images/rua.jpeg" alt="" />

            
            

       
       
           
                <img src="images/arte.jpeg" alt="" />
          
                <img src="images/casa.jpeg" alt=""/>
         
                <img src="images/igreja.jpeg" alt="" />

            

       
                <img src="images/moto.jpeg" alt="" />
           
                <img src="images/paisagem.jpeg" alt="" />
           
                <img src="images/paisagem2.jpeg" alt="" />

           
            

      
        
                <img src="images/rio.jpeg" alt="" />
           
                <img src="images/alemrio.jpeg" alt="" />
          
                <img src="images/casa4.jpeg" alt="" />

    
       
                <img src="images/igeja4.jpeg" alt="" />
          
                <img src="images/ponte4.jpeg" alt="" />
           
                <img src="images/rua4.jpeg" alt="" />

                
                
                <img src="images/lago.jpeg" alt="" />
          
                <img src="images/lago2.jpeg" alt="" />
     
                <img src="images/rua10.jpeg" alt="" />



          
            

       
                <img src="images/poste.jpeg" alt="" />
            
                <img src="images/ruaigreja.jpeg" alt=""/>
        
</div>
        )
}
export default FotosManoel